const company_country_options = [
    {text: '선택안함', text_en: 'No Select', value: null, code_value: null},
    {text: '중국', text_en: 'China', value: 'China', code_value: '+86'},
    {text: '동남아시아', text_en: 'Southeast Asia', value: 'Southeast Asia', code_value: null},
    {text: '터키', text_en: 'Turkey', value: 'Turkey', code_value: '+90'},
    {text: '브라질', text_en: 'Brazil', value: 'Brazil', code_value: '+55'},
    {text: '인도', text_en: 'India', value: 'India', code_value: '+91'},
    {text: '미국 - 알리바마', text_en: 'America - Alabama', value: 'America - Alabama', code_value: '+1'},
    {text: '루마니아', text_en: 'Romania', value: 'Romania', code_value: '+40'},
    {text: '체코', text_en: 'Czech', value: 'Czech', code_value: '+420'},
    {text: '폴란드', text_en: 'Poland', value: 'Poland', code_value: '+48'},
    {text: '헝가리', text_en: 'Hungary', value: 'Hungary', code_value: '+36'},
    {text: '룩셈브루크', text_en: 'Luxembourg', value: 'Luxembourg', code_value: '+352'},
    {text: '슬로바키아', text_en: 'Slovakia', value: 'Slovakia', code_value: '+421'},
    {text: '캐나다', text_en: 'Canada', value: 'Canada', code_value: '+1'},
    {text: '독일', text_en: 'Germany', value: 'Germany', code_value: '+49'},
    {text: '스페인', text_en: 'Spain', value: 'Spain', code_value: '+34'},
    {text: '프랑스', text_en: 'France', value: 'France', code_value: '+33'},
    {text: '미국', text_en: 'America', value: 'America', code_value: '+1'},
    {text: '인도네시아', text_en: 'Indonesia', value: 'Indonesia', code_value: '+62'},
    {text: '멕시코', text_en: 'Mexico', value: 'Mexico', code_value: '+52'},
    {text: '이탈리아', text_en: 'Italy', value: 'Italy', code_value: '+39'},
    {
        text: '남아프리카공화국',
        text_en: 'Republic of South Africa',
        value: 'Republic of South Africa',
        code_value: '+27'
    },
    {text: '스웨덴', text_en: 'Sweden', value: 'Sweden', code_value: '+46'},
    {text: '일본', text_en: 'Japan', value: 'Japan', code_value: '+81'},
    {text: '베트남', text_en: 'Vietnam', value: 'Vietnam', code_value: '+84'},
    {text: '미국 - 조지아', text_en: 'America - Georgia', value: 'America - Georgia', code_value: '+1'},
    {text: '한국', text_en: 'Korea', value: 'Korea', code_value: '+82'}
];

const nation_codes = [
    {'text': '선택안함', 'text_en': 'No Select', 'value': null},
    {'text': '미국 (+1)', 'text_en': 'America (+1)', 'value': '+1'},
    {'text': '캐나다 (+1)', 'text_en': 'Canada (+1)', 'value': '+1'},
    {'text': '남아프리카공화국 (+27)', 'text_en': 'Republic of South Africa (+27)', 'value': '+27'},
    {'text': '프랑스 (+33)', 'text_en': 'France (+33)', 'value': '+33'},
    {'text': '스페인 (+34)', 'text_en': 'Spain (+34)', 'value': '+34'},
    {'text': '헝가리 (+36)', 'text_en': 'Hungary (+36)', 'value': '+36'},
    {'text': '이탈리아 (+39)', 'text_en': 'Italy (+39)', 'value': '+39'},
    {'text': '루마니아 (+40)', 'text_en': 'Romania (+40)', 'value': '+40'},
    {'text': '스웨던 (+46)', 'text_en': 'Sweden (+46)', 'value': '+46'},
    {'text': '폴란드 (+48)', 'text_en': 'Poland (+48)', 'value': '+48'},
    {'text': '독일 (+49)', 'text_en': 'Germany (+49)', 'value': '+49'},
    {'text': '멕시코 (+52)', 'text_en': 'Mexico (+52)', 'value': '+52'},
    {'text': '브라질 (+55)', 'text_en': 'Brazil (+55)', 'value': '+55'},
    {'text': '인도네시아 (+62)', 'text_en': 'Indonesia (+62)', 'value': '+62'},
    {'text': '일본 (+81)', 'text_en': 'Japan (+81)', 'value': '+81'},
    {'text': '한국 (+82)', 'text_en': 'Korea (+82)', 'value': '+82'},
    {'text': '베트남 (+84)', 'text_en': 'Vietnam (+84)', 'value': '+84'},
    {'text': '중국 (+86)', 'text_en': 'China (+86)', 'value': '+86'},
    {'text': '터키 (+90)', 'text_en': 'Turkey (+90)', 'value': '+90'},
    {'text': '인도 (+91)', 'text_en': 'India (+91)', 'value': '+91'},
    {'text': '룩셈브루크 (+352)', 'text_en': 'Luxembourg (+352)', 'value': '+352'},
    {'text': '체코 (+420)', 'text_en': 'Czech (+420)', 'value': '+420'},
    {'text': '슬로바키아 (+421)', 'text_en': 'Slovakia (+421)', 'value': '+421'}
];

const assessment_clients = [
    {
        label: {
            ko: '원청사 선택',
            en: 'Select Main Contractor',
            ca: '选择总承包商',
        },
        value: null,
    },
    {
        label: {
            ko: '동국제강',
            en: 'Dongkuk Steel',
            ca: '东国制钢',
        },
        value: 'dongkuk_steel_2025'
    },
    {
        label: {
            ko: '고려제강',
            en: 'Kiswire',
            ca: '高丽制钢',
        },
        value: 'kiswire_2025'
    },
    {
        label: {
            ko: 'KG스틸',
            en: 'KG Steel',
            ca: 'KG钢铁',
        },
        value: 'kg_steel_2025'
    },
    {
        label: {
            ko: '포스코',
            en: 'POSCO',
            ca: '浦项制铁',
        },
        value: 'posco_2025'
    },
    {
        label: {
            ko: '세아베스틸',
            en: 'SeAH Besteel',
            ca: '世亚贝斯特钢铁',
        },
        value: 'seah_besteel_2025'
    },
    {
        label: {
            ko: '세아제강',
            en: 'SeAH Steel',
            ca: '世亚制钢',
        },
        value: 'seah_steel_2025'
    },
    {
        label: {
            ko: '세아창원특수강',
            en: 'SeAH CSS',
            ca: '世亚昌原特殊钢',
        },
        value: 'seah_css_2025'
    },
    
   
];
const clients_projects = {
    dongkuk_steel_2025: 'DONGKUK_STEEL_25',
    kiswire_2025: 'KISWIRE_25',
    kg_steel_2025: 'KG_STEEL_25',
    posco_2025: 'POSCO_25',
    seah_besteel_2025: 'SEAH_BESTEEL_25',
    seah_steel_2025: 'SEAH_STEEL_25',
    seah_css_2025: 'SEAH_CSS_25',
};

const role_mapping = {
    1: '기업 일반 참여자',
    2: '기업 평가 관리자',
};

const access_status_mapping = {
    0: '접근 가능',
    1: '접근 요청',
    2: '접근 거부'
};



export {company_country_options, nation_codes, assessment_clients, clients_projects, role_mapping,access_status_mapping};
